import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "input--wrapper" }
const _hoisted_4 = { class: "buttons-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-title bold" }, "Listing Configuration", -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "REA (realstate.com.au) AgentID", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              type: "text",
              placeholder: "Agent ID",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.agentIdForm) = $event)),
              maxlength: "6"
            }, null, 512), [
              [_vModelText, $setup.agentIdForm]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "button default outlined primary",
              onClick: $setup.close
            }, "Cancel"),
            _createElementVNode("button", {
              class: "button default primary cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.submit($setup.agentIdForm)))
            }, "Save")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}